import React, { ReactNode } from "react";
import SecNavigationDesktop from "../../../generic/SecNavigation/SecNavigationDesktop";
import { useRouteMatch, useParams } from "react-router-dom";
import FTSecNavOptions from "../ftConstants";
import { EdALinkButton } from "../../../generic/edButton";
import FtFaqLink from "../ftFaqLink";
import "../../../../assets/scss/components/generic/layout/layoutDesk.scss";

export interface IFtContainerDeskProps {
	instComp?: ReactNode;
}

const FtContainerDesk: React.FC<IFtContainerDeskProps> = (props) => {
	const routeParams = useRouteMatch();
	const { asset } = useParams<{ asset: string }>(); //section navigation,page navigation, primary market instrument

	const defaultValue: string = routeParams.url.split("/")[2] + (asset ? asset : "");
	return (
		<section className={"outer_container container_desk "}>
			<section className="lyCont">
				<section className=" list_view">
					{/* left block */}
					<div className="ly_list_view">
						<SecNavigationDesktop defaultValue={defaultValue || "add-funds"} list={FTSecNavOptions()} />
						<div className="ft_faq_link_wrap">
							<EdALinkButton
								value={<FtFaqLink />}
								btnTyp="link"
								LinkHref="https://www.edelweiss.in/faqs/what-is-upi-transfer-24-369"
								className="ft_faq"
							/>
						</div>
					</div>

					{/* right block which contains page navigation and other controls */}
					<div className="ly_right_cont">
						<div className="ftForm">{props.instComp}</div>
					</div>
				</section>
			</section>
		</section>
	);
};

export default FtContainerDesk;
